import { createAsyncRequestTypes } from 'utils';
export var PURCHASE_ORDER_DELIVERY_CONFIRMATION = '@@PURCHASE_ORDER_DELIVERY_CONFIRMATION@@';
export var LOCK_RECORD = createAsyncRequestTypes("".concat(PURCHASE_ORDER_DELIVERY_CONFIRMATION, "LOCK_RECORD"));
export var EDIT_LOCK_URL = 'purchaseorderdeliveryconfirmation/editlock';
export var SAVE_PO_DELIVERY_CONFIRMATION = createAsyncRequestTypes("".concat(PURCHASE_ORDER_DELIVERY_CONFIRMATION, "SAVE_PO_DELIVERY_CONFIRMATION"));
export var SAVE_URL = 'purchaseorderdeliveryconfirmation/update';
export var CHANGE_DELIVERY_DATE = "".concat(PURCHASE_ORDER_DELIVERY_CONFIRMATION, "CHANGE_DELIVERY_DATE");
export var poDeliveryConfirmationform = 'poDeliveryConfirmation';
export var poDeliveryConfirmationRoute = 'purchaseOrderDeliveryConfirmation';
export var LAUNCH_NOTES_MODAL = "".concat(PURCHASE_ORDER_DELIVERY_CONFIRMATION, "LAUNCH_NOTES_MODAL");
